import React, { useEffect, useState } from "react";
import styles from "./index.module.less";
import { Context,Hooks,Util,Request } from "@xt/xtbase";
import QrCode from "@xt/QrCode";
import recommendImg from "assets/images/home/recommend.png";
import recommend1Img from "assets/images/home/recommend1.png";
import jia from "assets/images/home/jia.png";
import jian from "assets/images/home/jian.png";
import arrow from "assets/images/home/arrow.png";
import Immediate from "assets/images/home/Immediate.png";
import Rectangle from "assets/images/home/Rectangle.png";
import Rectangle1 from "assets/images/home/Rectangle1.png";
import jieshuo from "assets/images/home/jieshuo.png";
import Nodata from "assets/images/home/nodata.png";
import Union from "assets/images/home/Union.png";
import { Collapse, Anchor, Tooltip, Table, Space } from 'antd';
import Screening from './screening';
import {get_commissionInvitees, get_commissionList, get_commissionBackList, get_profileInfo} from "@/api/referral";
import CopyPagination from "../../../App/copyPagination"
import { toUtc } from "utils/date";
import ExportModal from "./exportModal";

const { Link } = Anchor;
const { Panel } = Collapse;
const {XtContext,XtAuth} = Context;
const {getOrigin, getUrl} = Util;
const {useTranslation, useDocumentWidth, Trans} = Hooks;

function Content({ showLoggedInReferralMain = false }) {
  const t = useTranslation();
  const domeWidth = (useDocumentWidth() ?? 0) > 768
  const [appState] = React.useContext(XtContext);
  const {loginStatus, lang} = appState;
  const [loginQuery, setLoginQuery] = useState("");
  const {immediate, immediateTitle, logIn, faqContent, jiaImg, jianImg, content, recommend, recommendTitle, rightArrowImg, recommendStep, step, stepCircle, stepNumber, stepLine, stepContent, stepLabel, stepCard, bL, bR,
    stepNumberTitle, setting, settingTip, faq, faqItem, rectangleC, rectangle, rectangleTitle, rectangleText, part, partT, partB, partM, part1, part2, part3, part4,
    partTitle, jieshuoImg, nodataImg, nodata, nodataTitle, UnionImg, UnionTitle, union, exportO, exportTip, tabs, tabItem, tabItemActive, faqItemP, pagination} = styles

  const [commissionInvitees, setCommissionInvitees] = useState([])
  const [commissionList, setCommissionList] = useState([])
  const [commissionBackList, setCommissionBackList] = useState([])
  const [activeIndex, setActiveIndex] = useState(1)
  const [activeIndex1, setActiveIndex1] = useState(1)
  const [activeVisible, setActiveVisible] = useState(true)
  const [hasPrev, setHasPrev] = useState(false)
  const [hasNext, setHasNext] = useState(false)
  const [hasPrev1, setHasPrev1] = useState(false)
  const [hasNext1, setHasNext1] = useState(false)
  const [hasPrev2, setHasPrev2] = useState(false)
  const [hasNext2, setHasNext2] = useState(false)
  const [isActivePage, setIsActivePage] = useState(true)

  const [isShowExportModal, setIsShowExportModal] = useState(false)
  const [columnsExport, setColumnsExport] = useState([])
  const [titleExport, setTitleExport] = useState('')
  const [indexExport, setIndexExport] = useState(null)

  const [profileInfo, setProfileInfo] = useState({})

  /** false：新版 Referral Tab 承载总览；true：灰度未命中时恢复旧版正文区展示 */
  const onCloseExportModal = () => {
    setIsShowExportModal(false)
  }

  const onOkExportModal = (index) => {
    if(index == 1) {
      setTitleExport(t('home.myFriends'))
      setColumnsExport(columns)
    } else if(index == 2) {
      setTitleExport(t('home.commission'))
      setColumnsExport(columns1)
    } else if(index == 3) {
      setTitleExport(t('home.back'))
      setColumnsExport(columns2)
    }
    setIndexExport(index)
    setIsShowExportModal(true)
  }

  const renderAnswer1 = () => {
    return (
        <Trans
            i18nKey="home.answer1"
            components={{
                1: <a />,
            }}
        />
    );
  };

  const handleScroll = (e) => {
    //定义handleScroll事件函数
    let header = document.getElementById('partM');
    let currentOffset = document.documentElement.scrollTop; // 滚动的距离
    if (currentOffset > 648) {
        header?.classList.add('nav-header-change');
    } else {
        header?.classList.remove('nav-header-change');
    }
  }

  useEffect(()=>{
    setLoginQuery("?backurl="+encodeURIComponent(location.href));
    window.addEventListener('scroll',handleScroll)
    const getData = async() => {
      getCommissionInvitees()
      getCommissionList()
      getCommissionBackList()
      getProfileInfo()
    }
    if (loginStatus == 1 && showLoggedInReferralMain) {
      getData()
    }
    return ()=>{
      window.removeEventListener("scroll", handleScroll)
    }
  }, [loginStatus, showLoggedInReferralMain])

  const getProfileInfo = async() => {
    const profileInfo = await get_profileInfo()
    setProfileInfo(profileInfo || {})
  }

  const onPrev = () => {
    setIsActivePage(false)
    const fromId = commissionInvitees[0]?.id;

    const direction = 'PREV';
    if (fromId) {
      getCommissionInvitees(direction, fromId);
    }
  };

  const onNext = () => {
    setIsActivePage(false)
    const direction = 'NEXT';
    const fromId = commissionInvitees[commissionInvitees.length - 1]?.id;

    if (fromId) {
      getCommissionInvitees(direction, fromId);
    }
  };

  const onPrev1 = () => {
    setIsActivePage(false)
    const fromId = commissionList[0]?.id;

    const direction = 'PREV';
    if (fromId) {
      getCommissionList(direction, fromId);
    }
  };

  const onNext1 = () => {
    setIsActivePage(false)
    const direction = 'NEXT';
    const fromId = commissionList[commissionList.length - 1]?.id;

    if (fromId) {
      getCommissionList(direction, fromId);
    }
  };

  const onPrev2 = () => {
    setIsActivePage(false)
    const fromId = commissionBackList[0]?.id;

    const direction = 'PREV';
    if (fromId) {
      getCommissionBackList(direction, fromId);
    }
  };

  const onNext2 = () => {
    setIsActivePage(false)
    const direction = 'NEXT';
    const fromId = commissionBackList[commissionBackList.length - 1]?.id;

    if (fromId) {
      getCommissionBackList(direction, fromId);
    }
  };

  const getCommissionInvitees = async(direction, fromId) => {
    const commissionInvitees = await get_commissionInvitees({
      params: {
        limit: 5,
        direction,
        fromId
      }
    })
    setCommissionInvitees(commissionInvitees?.items || []);
    setHasNext(commissionInvitees?.hasNext || false)
    setHasPrev(commissionInvitees?.hasPrev || false)
    setIsActivePage(true)
  }

  const getCommissionList = async(direction, fromId, index = activeIndex) => {
    let bizType = ''
    if (index == 1) {
      bizType = ''
    } else if (index == 2) {
      bizType = 'SPOT'
    } else if (index == 3) {
      bizType = 'FUTURES'
    } 
    const commissionList = await get_commissionList({
      params: {
        limit: 10,
        bizType: bizType ? bizType : undefined,
        direction: direction ? direction : undefined,
        fromId: fromId ? fromId : undefined
      }
    })
    setCommissionList(commissionList?.items || [])
    setHasNext1(commissionList?.hasNext || false)
    setHasPrev1(commissionList?.hasPrev || false)
    setIsActivePage(true)
  }

  const getCommissionBackList = async(direction, fromId, index = activeIndex1) => {
    let bizType = ''
    if (index == 1) {
      bizType = ''
    } else if (index == 2) {
      bizType = 'SPOT'
    } else if (index == 3) {
      bizType = 'FUTURES'
    } 
    const commissionBackList = await get_commissionBackList({
      params: {
        limit: 10,
        bizType: bizType ? bizType : undefined,
        direction: direction ? direction : undefined,
        fromId: fromId ? fromId : undefined
      }
    })
    setCommissionBackList(commissionBackList?.items || [])
    setHasNext2(commissionBackList?.hasNext || false)
    setHasPrev2(commissionBackList?.hasPrev || false)
    setIsActivePage(true)
  }

  const columns = [
    {
      title: t("home.friendId"),
      dataIndex: 'userId',
      key: 'userId',
    },
    {
      title: t("console.board.registerTime"),
      dataIndex: 'regTime',
      key: 'regTime',
      render: (time) => toUtc(Number(time)),
    },
    {
      title: t("home.rebateCash"),
      dataIndex: 'selfCommissionRate',
      key: 'selfCommissionRate',
      render: (_, record) => (
        <Space size="middle">
          <span>{(record.selfCommissionRate * 100).toFixed(0) + '%' + "/" + (record.inviteeCommissionRate * 100).toFixed(0) + '%'}</span>
        </Space>
      ),
    },
    {
      title: t("home.accountStatus"),
      dataIndex: 'isLoginLimit',
      key: 'isLoginLimit',
      render: (_, record) => (
        <Space size="middle">
          <span>{record.isLoginLimit ? t("console.abidden") : t("console.normal")}</span>
        </Space>
      ),
    },
    {
      title: t("home.isTrade"),
      dataIndex: 'isTrade',
      key: 'isTrade',
      render: (_, record) => (
        <Space size="middle">
          <span>{record.isTrade ? t("console.yes") : t("console.no")}</span>
        </Space>
      ),
    }
  ]

  const columns1 = [
    {
      title: t("home.accountType"),
      dataIndex: 'bizType',
      key: 'bizType',
      render: (_, record) => (
        <Space size="middle">
          <span>{record.bizType == 'SPOT' ? t("home.spot") : t("home.agreement")}</span>
        </Space>
      ),
    },
    {
      title: t("home.inviteeOfID"),
      dataIndex: 'userId',
      key: 'userId',
    },
    {
      title: t("home.commissionRevenue"),
      dataIndex: 'rebateAmount',
      key: 'rebateAmount',
      render: (_, record) => (
        <Space size="middle">
          <span>{`${record.rebateAmount}(${record.rebateCurrency})`}</span>
        </Space>
      ),
    },
    {
      title: t("console.peoplelist.tradeTime"),
      dataIndex: 'tradeTime',
      key: 'tradeTime',
      render: (time) => toUtc(Number(time)),
    },
    {
      title: t("home.rebateTime"),
      dataIndex: 'rebateTime',
      key: 'rebateTime',
      render: (time) => toUtc(Number(time)),
    }
  ]

  const columns2 = [
    {
      title: t("home.accountType"),
      dataIndex: 'bizType',
      key: 'bizType',
      render: (_, record) => (
        <Space size="middle">
          <span>{record.bizType == 'SPOT' ? t("home.spot") : t("home.agreement")}</span>
        </Space>
      ),
    },
    {
      title: t("home.commissionRevenue"),
      dataIndex: 'rebateAmount',
      key: 'rebateAmount',
      render: (_, record) => (
        <Space size="middle">
          <span>{`${record.rebateAmount}(${record.rebateCurrency})`}</span>
        </Space>
      ),
    },
    {
      title: t("console.peoplelist.tradeTime"),
      dataIndex: 'tradeTime',
      key: 'tradeTime',
      render: (time) => toUtc(Number(time)),
    },
    {
      title: t("home.rebateTime"),
      dataIndex: 'rebateTime',
      key: 'rebateTime',
      render: (time) => toUtc(Number(time)),
    }
  ]

  const changeActiveIndex = (index) =>{
    if (index != activeIndex) {
      setActiveVisible(false)
      setActiveIndex(index)
      getCommissionList('','',index)
      setTimeout(()=>{
        setActiveVisible(true)
      },200)
      
    }
  }

  const changeActiveIndex1 = (index) =>{
    if (index != activeIndex1) {
      setActiveVisible(false)
      setActiveIndex1(index)
      getCommissionBackList('','',index)
      setTimeout(()=>{
        setActiveVisible(true)
      },200)
    }
  }

  return (
    <div className={`${content} referral`}>
      { showLoggedInReferralMain && loginStatus == 1 && domeWidth && (
        <div className={rectangleC} style={{backgroundImage:`url(${Rectangle})`}}>
          <div className={rectangle} style={{backgroundImage:`url(${Rectangle1})`}}>
            <div className={rectangleTitle}>{ t("home.01") }</div>
            <div className={rectangleText}>{ t("home.copyLink") }</div>
          </div>
          <div className={rectangle} style={{backgroundImage:`url(${Rectangle1})`}}>
            <div className={rectangleTitle}>{ t("home.02") }</div>
            <div className={rectangleText}>{ t("home.invite") }</div>
          </div>
          <div className={rectangle} style={{backgroundImage:`url(${Rectangle1})`}}>
            <div className={rectangleTitle}>{ t("home.03") }</div>
            <div className={rectangleText}>{ t("home.free") }</div>
          </div>
        </div>
      )}
      {
        showLoggedInReferralMain && loginStatus == 1 && domeWidth && (
          <div className={part}>
            <div className={partM} id="partM">
              <div className={partT}>
                <Anchor offsetTop={60} targetOffset={60}>
                  <Link href="#part1" title={t('home.screening')} />
                  <Link href="#part2" title={t('home.myFriends')} />
                  <Link href="#part3" title={t('home.earnings1')} />
                  <Link href="#part4" title={t('home.earnings2')} />
                </Anchor>
              </div>
            </div>
            <div className={partB}>
              <div id="part1" className={part1}>
                <div className={partTitle}>{t('home.screening')}
                  <Tooltip placement="topLeft" title={t('home.screeningTip')}>
                    <img src={jieshuo} className={jieshuoImg} />
                  </Tooltip>
                </div>
                <Screening profileInfo={profileInfo} />
              </div>
              <div id="part2" className={part2}>
                <div className={partTitle}>{t('home.myFriends')}
                  {/* <Tooltip placement="topLeft" title={t('home.screeningTip')}>
                    <img src={jieshuo} className={jieshuoImg} />
                  </Tooltip> */}
                </div>
                {commissionInvitees.length != 0 && <Table pagination={false} dataSource={commissionInvitees} columns={columns} />}
                {commissionInvitees.length == 0 && <div className={nodata}>
                  <img src={Nodata} className={nodataImg} />
                  <div className={nodataTitle}>{ t("home.NoRecent") }</div>
                </div>}
                {/* <div className={union}>
                  <div></div>
                  <div className={exportO} onClick={()=>onOkExportModal(1)}>
                    <img src={Union} className={UnionImg} />
                    <div className={UnionTitle}>{ t("home.export") }</div>
                  </div>
                </div> */}
                {commissionInvitees.length != 0 && <div className={pagination}>
                  <CopyPagination
                    position="center"
                    hasPrev={hasPrev}
                    hasNext={hasNext}
                    onPrev={onPrev}
                    onNext={onNext}
                    isActivePage={isActivePage}
                  />
                </div>}
              </div>
              <div id="part3" className={part3}>
                <div className={partTitle}>{t('home.earnings1')}
                  <Tooltip placement="topLeft" title={t('home.commissionTip')}>
                    <img src={jieshuo} className={jieshuoImg} />
                  </Tooltip>
                </div>
                <div className={tabs}>
                  <div className={activeIndex == 1 ? tabItemActive : tabItem} onClick={()=>changeActiveIndex(1)}>{t('console.all')}</div>
                  <div className={activeIndex == 2 ? tabItemActive : tabItem} onClick={()=>changeActiveIndex(2)}>{t('home.spot')}</div>
                </div>
                {commissionList.length != 0 && <Table pagination={false} dataSource={commissionList} columns={columns1} />}
                {commissionList.length == 0 && <div className={nodata}>
                  <img src={Nodata} className={nodataImg} />
                  <div className={nodataTitle}>{ t("home.NoRecent") }</div>
                </div>}
                <div className={union}>
                  <div className={exportTip}>{ t("home.exportTip1") }</div>
                  <div className={exportO} onClick={()=>onOkExportModal(2)}>
                    <img src={Union} className={UnionImg} />
                    <div className={UnionTitle}>{ t("home.export") }</div>
                  </div>
                </div>
                {commissionList.length != 0 && activeVisible && <div className={pagination}>
                  <CopyPagination
                    position="center"
                    hasPrev={hasPrev1}
                    hasNext={hasNext1}
                    onPrev={onPrev1}
                    onNext={onNext1}
                    isActivePage={isActivePage}
                  />
                </div>}
              </div>
              <div id="part4" className={part4}>
                <div className={partTitle}>{t('home.earnings2')}
                  <Tooltip placement="topLeft" title={t('home.backTip')}>
                    <img src={jieshuo} className={jieshuoImg} />
                  </Tooltip>
                </div>
                <div className={tabs}>
                  <div className={activeIndex1 == 1 ? tabItemActive : tabItem} onClick={()=>changeActiveIndex1(1)}>{t('console.all')}</div>
                  <div className={activeIndex1 == 2 ? tabItemActive : tabItem} onClick={()=>changeActiveIndex1(2)}>{t('home.spot')}</div>
                </div>
                {commissionBackList.length != 0 && <Table pagination={false} dataSource={commissionBackList} columns={columns2} />}
                {commissionBackList.length == 0 && <div className={nodata}>
                  <img src={Nodata} className={nodataImg} />
                  <div className={nodataTitle}>{ t("home.NoRecent") }</div>
                </div>}
                <div className={union}>
                  <div className={exportTip}>{ t("home.exportTip2") }</div>
                  <div className={exportO} onClick={()=>onOkExportModal(3)}>
                    <img src={Union} className={UnionImg} />
                    <div className={UnionTitle}>{ t("home.export") }</div>
                  </div>
                </div>
                {commissionBackList.length != 0 && activeVisible && <div className={pagination}>
                  <CopyPagination
                    position="center"
                    hasPrev={hasPrev2}
                    hasNext={hasNext2}
                    onPrev={onPrev2}
                    onNext={onNext2}
                    isActivePage={isActivePage}
                  />
                </div>}
              </div>
            </div>
          </div>
        )
      }
      { showLoggedInReferralMain && loginStatus == 1 && !domeWidth && (
        <div id="part1" className={part1}>
          <div className={partTitle}>{t('home.screening')}
            <Tooltip placement="topLeft" title={t('home.screeningTip')}>
              <img src={jieshuo} className={jieshuoImg} />
            </Tooltip>
          </div>
          <Screening profileInfo={profileInfo} />
        </div>
      )}
      {/* <div className={immediate}>
          <h2 className={immediateTitle}>{ loginStatus == 1 ? t("home.partner") : t("home.Immediate") }</h2> */}
          {/* <a className={logIn} href={loginStatus == 1 ? `${getUrl("/affiliate/application")}` : `${getUrl("/accounts/login"+loginQuery)}`}>
            { loginStatus == 1 ? t("home.apply1") : t("home.logIn") }
          </a> */}
          {/* <a className={logIn} href={profileInfo?.isPartner ? `${getUrl("/affiliate/admin")}` : (loginStatus == 1 ? `${getUrl("/affiliate")}` : `${getUrl("/accounts/login"+loginQuery)}`)} >
            { profileInfo?.isPartner ? t("home.enterAdmin") : (loginStatus == 1 ? t("home.apply1") : t("home.logIn")) }
          </a>
      </div> */}
      {isShowExportModal && <ExportModal onClose={onCloseExportModal} isShowModal={isShowExportModal} columns={columnsExport} title={titleExport} index={indexExport} activeIndex={activeIndex} activeIndex1={activeIndex1}/>}
    </div>
  );
}

export default Content;
